import { parseISO } from 'date-fns'

import {
  useIsPast,
  Banner,
  FormattedMessage,
  parseOptionalISODate,
  DateTimeFormatType,
  ClientTimeZoneDateTime,
} from '@b-stock/fe-core/bstock-react'
import { CommonStrings } from '@b-stock/fe-core/locale'
import type { OfferingDto, OfferDto } from '@b-stock/offering-api-client'

import useAccount from '@/buyer-portal/helpers/useAccount'

const ns = 'Offerings.Details.offeringStatusBanner.expiredOfferTime'

export const ExpiredOfferingBanner = ({
  offering,
  offers,
  ignoreOffers,
}: {
  offering: OfferingDto
  offers: OfferDto[]
  ignoreOffers: boolean
}) => {
  const { offerEndTime = '' } = offering
  const { data: account } = useAccount(offering.accountId)

  const offerEndTimeIsPast = useIsPast(parseISO(offerEndTime))

  const sellerName = account?.business?.displayName || (
    <CommonStrings.NotAvailableAbbr.Component />
  )

  const showDecisionMessage = offers.length > 0 && !ignoreOffers

  return (
    <Banner title={<FormattedMessage id={`${ns}.title`} />}>
      <div>
        <FormattedMessage
          id={`${ns}.decisionWindowMessage.${offerEndTimeIsPast ? 'offerEndTimeIsPast' : 'earlyOfferAccept'}`}
          values={{
            date: (
              <ClientTimeZoneDateTime
                dateTime={parseOptionalISODate(offering.offerEndTime)}
                format={DateTimeFormatType.FULL}
              />
            ),
          }}
        />
        {showDecisionMessage ? (
          <FormattedMessage
            id={`${ns}.sellerDecisionMessage`}
            values={{
              sellerName,
            }}
          />
        ) : null}
      </div>
      {showDecisionMessage ? (
        <div>
          <FormattedMessage
            id={`${ns}.furtherStepsMessage`}
            values={{
              sellerName,
            }}
          />
        </div>
      ) : null}
    </Banner>
  )
}
